import { CALL_API } from "admin/middlewares/api";

export const TRUSTLY_ACCOUNT_BALANCE_FETCH_REQUEST =
  "TRUSTLY_ACCOUNT_BALANCE_FETCH_REQUEST";
export const TRUSTLY_ACCOUNT_BALANCE_FETCH_SUCCESS =
  "TRUSTLY_ACCOUNT_BALANCE_FETCH_SUCCESS";
export const TRUSTLY_ACCOUNT_BALANCE_FETCH_ERROR =
  "TRUSTLY_ACCOUNT_BALANCE_FETCH_ERROR";

export function fetch_trustly_account_balance(currency) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/trustly-balances",
      method: "GET",
      authenticatedRequest: true,
      additionalData: { Currency: currency },
      types: [
        TRUSTLY_ACCOUNT_BALANCE_FETCH_REQUEST,
        TRUSTLY_ACCOUNT_BALANCE_FETCH_SUCCESS,
        TRUSTLY_ACCOUNT_BALANCE_FETCH_ERROR,
      ],
    },
  };
}

export const ACCOUNT_BALANCE_CHANGE_DATE = "ACCOUNT_BALANCE_CHANGE_DATE";

// DateType == "From" || "To" || "Selected"
export function change_date(dateType, date) {
  return {
    type: ACCOUNT_BALANCE_CHANGE_DATE,
    dateType,
    date,
  };
}
